<template>
  <!-- 登录页面 -->
  <div id="loginContainer">
    <div class="loginBox">
      <div class="logo">
        <img src="../assets/index/logo.png" />
      </div>
      <div class="login">
        <div class="version" v-if="(maxopennum < 999 && mallver == 'v2' && userId) || (maxopennum < 999 && mallver == 'v2' && wxgenerateid)">
          <img class="version-one" src="../assets/index/tyb.png" />
          <span>体验版</span>
        </div>
        <div class="version" v-if="(maxopennum > 999 && mallver == 'v2' && userId) || (maxopennum > 999 && mallver == 'v2' && wxgenerateid)">
          <img class="version-two" src="../assets/index/zyb.png" />
          <span>专业版</span>
        </div>
        <div class="version" v-if="(mallver == 'v1' && userId) || (mallver == 'v1' && wxgenerateid)">
          <img class="version-three" src="../assets/index/zzyh.png" />
          <span style="color: #1EA638">种子用户</span>
        </div>
        <!-- <p v-if="accounttype == 80" style="margin-right: 10px">ss</p> -->
        <p v-if="userId || wxgenerateid" @click="showMenu" class="userBGTitle" :class="mallver == 'v1' ? 'versionV1': ''">
          <span>{{ userId || wxgenerateid}}</span>
        </p>
        <div v-else style="display: flex; align-items: center">
          <p>
            <span class="word" @click="login">登录</span>
          </p>
          <p style="margin-right: 10px">|</p>
          <p>
            <span class="word" @click="applyLogin">注册</span>
          </p>
        </div>
        <p class="replay" @click="repalyBtn">
          <!-- <van-button
            :disabled="
              accountstatus == 300 || accountstatus == 400 ? true : false
            "
            type="warning"
            size="mini"
            style="padding-left:20px;font-size:12px"
            @click="repalyBtn"
          >
          </van-button> -->
          <img class="replayimg" src="../assets/index/replay.png" />
            <span>刷新</span>
        </p>
      </div>
    </div>
    <!-- 新加 add -->
    <van-action-sheet
      v-model="show"
      :actions="actionOptions"
      @select="onSelect"
      get-container="body"
    />
    <van-dialog
      v-model="bindPhonePop"
      title="绑定手机号"
      :show-confirm-button="false"
      className="bind-phone-dialog">
        <van-icon name="cross" class="bind-close-icon" @click="closeBindPhone" />
        <van-cell-group>
          <van-field
            v-model="bindTel"
            type="number"
            clearable
            placeholder="请输入手机号"
            :error-message="errMsg.bindTel"
          />
          <van-field
            v-model="bindSms"
            clearable
            placeholder="请输入验证码"
            :error-message="errMsg.bindSms"
          >
            <template #button>
               <van-button v-if="isSend" disabled class="verificate-code" size="small">
                 剩余{{count}}S
               </van-button>
              <van-button v-if="!isSend" class="verificate-code" size="small" @click="getSmsCode(6)">
                获取验证码
              </van-button>
            </template>
          </van-field>
        </van-cell-group>
        <div class="login-btn-wapper" @click="sureVerify(6)">
          <van-button class="login-btn" round type="info">确定</van-button>
        </div>
    </van-dialog>
    <!--新加 start -->
    <!-- 重置微信pop -->
    <van-dialog
      v-model="bindResetWxPop"
      title="重置微信"
      :show-confirm-button="false"
      className="reset-wx-dialog">
        <van-icon name="cross" class="reset-wx-icon" @click="closeResetWx" />
          <div style="margin: 10px 0">
            <div class="nav-title">手机号码:</div>
            <van-cell center :value="phone | mobileFilter" />
          </div>
          <div style="margin: 15px 0">
            <div class="nav-title">验证码：</div>
            <van-field
              v-model="bindSms"
              clearable
              placeholder="请输入验证码"
              :error-message="errMsg.bindSms"
            >
              <template #button>
                <van-button v-if="isSend" disabled class="verificate-code" size="small">
                  剩余{{count}}S
                </van-button>
                <van-button v-if="!isSend" class="verificate-code" size="small" @click="getSmsCode(8)">
                  获取验证码
                </van-button>
              </template>
            </van-field>
          </div>
        <div class="login-btn-wapper" @click="sureVerify(8)">
          <van-button :disabled="!isSend" class="login-btn" round type="info">确定</van-button>
        </div>
    </van-dialog>
    <login ref="alertModel" @refreshProtect="refreshProtect"></login>
    <!-- 切换版本 -->
    <van-popup v-model="show1" position="top" get-container="body">
      <van-divider
        :style="{
          color: '#1989fa',
          borderColor: '#1989fa',
          fontSize: '17px',
          marginTop: '40px',
        }"
      >
        版本切换
      </van-divider>
      <van-radio-group v-model="radio" @change="changeVersion">
        <van-cell-group>
          <van-cell
            title="地方版"
            clickable
            @click="radio = '1'"
            style="border: none; margin: 0; min-height: 0"
          >
            <template #right-icon>
              <van-radio name="1" />
            </template>
          </van-cell>
          <van-cell
            title="全国版"
            clickable
            @click="radio = '2'"
            style="border: none; margin: 0; min-height: 0"
          >
            <template #right-icon>
              <van-radio name="2" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div style="margin-top: 40px"></div>
    </van-popup>
    <!-- 账号信息 -->
    <van-popup
      v-model="showAccMsg"
      position="bottom"
      :style="{ height: '32%' }"
      get-container="body"
    >
      <van-divider :style="{ fontSize: '18px', marginTop: '40px' }">
        账号信息
      </van-divider>
      <div
        class="acc"
        style="line-height: 40px; margin: 0 30px; font-size: 18px"
      >
        账号：{{ userId }}
      </div>
      <div
        class="acc"
        style="line-height: 40px; margin: 0 30px; font-size: 18px"
      >
        手机：{{ phone | mobileFilter }}
      </div>
    </van-popup>
    <!-- 修改手机号码 旧手机号码 -->
    <van-popup
      v-model="showOldPhonePopup"
      round
      position="bottom"
      closeable
      @open="openOldPhonePopup"
      get-container="body"
    >
      <div class="loginContent1" style="margin: 16px 0px 20px">
        <div class="content" style="padding: 10px 20px 20px">
          <div
            class="title titleStyleAll"
            style="
              font-weight: 600;
              text-align: center;
              margin-bottom: 28px;
              font-size: 18px;
              color:#000000;
            "
          >
            更换手机号码
          </div>
          <van-steps :active="activePhone">
            <van-step>
              <template slot="active-icon">
                <img class="edit-phone-img" :src="stepOne">
              </template>
              <template slot="inactive-icon">
                <img class="edit-phone-img" :src="stepOneUn">
              </template>
              验证身份
            </van-step>
            <van-step>
              <template slot="active-icon">
                <img class="edit-phone-img" :src="stepTwo">
              </template>
              <template slot="inactive-icon">
                <img class="edit-phone-img" :src="stepTwoUn">
              </template>
              修改手机
              </van-step>
            <van-step>
              <template slot="active-icon">
                <img class="edit-phone-img" :src="stepThree">
              </template>
              <template slot="inactive-icon">
                <img class="edit-phone-img" :src="stepThreeUn">
              </template>
              完成
            </van-step>
          </van-steps>
          <div style="margin-top: 20px; font-size: 0.32rem; color: #808080">
            为确认是您本人操作，请完成以下验证
          </div>
          <div style="margin-top: 20px; font-size: 14px; color: #000000">
            手机号码：{{ phone | mobileFilter }}
          </div>
          <div class="exchange-wapper">
            <van-field
              v-model="oldCode"
              center
              clearable
              type="number"
              maxlength="6"
              placeholder="请输入短信验证码"
              @blur="changeCode"
              :error-message="errMsg.oldcode"
            >
            </van-field>
              <van-button
                :disabled="disabled"
                size="small"
                type="info"
                @click="sendcode(1)"
                >{{ btntxt }}</van-button
            >
          </div>
          <div style="margin-top: 30px" @click="beforeOldPhoneClose">
            <van-button block type="info" style="border-radius: 30px"
              >确定</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 修改手机号码 新手机号码 -->
    <van-popup
      v-model="showNewPhonePopup"
      round
      position="bottom"
      closeable
      @open="openNewPhonePopup"
      get-container="body"
    >
      <div class="loginContent1" style="margin: 16px 0px 20px">
        <div class="content" style="padding: 10px 20px 20px">
          <div
            class="title titleStyleAll"
            style="
              font-weight: 600;
              text-align: center;
              margin-bottom: 28px;
              font-size: 18px;
              color:#000000;
            "
          >
            更换手机号码
          </div>
          <van-steps :active="activePhone">
            <van-step>
              <template slot="active-icon">
                <img class="edit-phone-img" :src="stepOne">
              </template>
              <template slot="inactive-icon">
                <img class="edit-phone-img" :src="stepOneUn">
              </template>
              验证身份</van-step>
            <van-step>
              <template slot="active-icon">
                <img  class="edit-phone-img" :src="stepTwo">
              </template>
              <template slot="inactive-icon">
                <img class="edit-phone-img" :src="stepTwoUn">
              </template>
              修改手机</van-step>
            <van-step>
               <template slot="active-icon">
                <img class="edit-phone-img" :src="stepThree">
              </template>
              <template slot="inactive-icon">
                <img class="edit-phone-img" :src="stepThreeUn">
              </template>完成</van-step>
          </van-steps>
          <div style="margin:20px 0; font-size: 0.32rem; color: #715641">
            请输入更换后的手机号码，进行验证
          </div>
          <div class="new-exchange-wapper">
            <van-cell-group>
            <van-field
              v-model="newMoblie"
              center
              clearable
              type="number"
              maxlength="11"
              placeholder="请输入11位手机号码"
              @blur="checkNewMobile"
              :error-message="errMsg.newMobile"
            />
            <van-field
              v-model="newCode"
              center
              clearable
              type="number"
              maxlength="6"
              placeholder="请输入短信验证码"
              @blur="changeCodeNew"
              :error-message="errMsg.newcode"
            >
              <template #button>
                <van-button
                  :disabled="disabled"
                  size="small"
                  type="info"
                  @click="sendcode(2)"
                  >{{ btntxt }}</van-button
                >
              </template>
            </van-field>
          </van-cell-group>
          </div>
          
          <div style="margin-top: 30px" @click="beforeNewPhoneClose">
            <van-button block type="info" style="border-radius: 30px"
              >确定</van-button
            >
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 意见反馈弹框 -->
    <van-popup
      v-model="feedBack"
      closeable
      position="bottom"
      :style="{ height: '100%' }"
      get-container="body"
    >
      <van-divider :style="{ fontSize: '18px', marginTop: '40px' }">
        意见反馈
      </van-divider>
      <div class="feed-back-box">
        <div style="height: 100%">
          <van-field
            v-model="feedBackMessage"
            rows="14"
            autosize
            type="textarea"
            placeholder="请输入意见/反馈内容"
          />
        </div>
      </div>
      <div class="btn-buju">
        <van-button
          style="width: 30%; border-radius: 30px; height: 40px"
          type="default"
          @click="clocsFeed"
          >取消</van-button
        >
        <van-button
          style="width: 30%; border-radius: 30px; height: 40px"
          type="info"
          @click="confirmFeedBack"
          >确定</van-button
        >
      </div>
    </van-popup>
    <!-- 修改密码 -->
    <van-popup
      v-model="updPassword"
      closeable
      round
      position="bottom"
      get-container="body"
    >
      <div id="updatePwd-dialog">
        <div class="pwd-title">修改密码</div>
        <div style="padding: 10px 20px 20px">
          <van-cell-group>
            <van-field
              v-model="oldPwd"
              center
              clearable
              label="旧密码"
              type="password"
              placeholder="请输入旧密码"
              @blur="checkOldPwd"
              :error-message="errMsg.oldPwd"
            />
            <van-field
              v-model="newPwd"
              center
              clearable
              label="新密码"
              type="password"
              placeholder="请输入新密码"
              @blur="changeNewPwd"
              :error-message="errMsg.newPwd"
            >
            </van-field>
            <van-field
              v-model="confirmPwd"
              center
              clearable
              label="确认密码"
              type="password"
              placeholder="请输入确认密码"
              @blur="changeConfirmPwd"
              :error-message="errMsg.confirmPwd"
            >
            </van-field>
          </van-cell-group>
          <div style="margin-top: 30px" @click="confirmUpdatePwd">
            <van-button block type="info" style="border-radius: 30px"
              >确定</van-button
            >
          </div>
       </div>
      </div>
    </van-popup>
    <!-- 推广码 -->
    <div class="qr-pop">
      <van-popup v-model="showQrcode" closeable
        :style="{ width: '90%'}">
        <div class="qr-top-section">
          <van-image width="60" height="60" :src="txImg" />
          <div class="information-box">
            <div class="account-line">
              <span>账号：{{userId}}</span>
            </div>
            <div class="phone-line">
              <span>手机：{{ phone | mobileFilter }}</span>
            </div>
          </div>
        </div>
        <!-- <img class="frame-img" :src="frameImg"> -->
        <div id="deposit_qrcode" ref="deposit_qrcode"></div>
        
        <!-- <div class="already-bind"  v-if="bindJgjSta">已绑定分销商</div>
        <div class="bind-id" v-if="bindJgjSta">分销商ID：{{bindJgjId}}</div>
        <div v-if="bindJgjSta" class="bind-people" @click="openBind">
          <van-button>分销商操作指引</van-button>
        </div>
        <div class="bind-people" v-else>
          <van-button  @click="openBind">绑定分销商</van-button>
        </div> -->
        <div class="bind-people">
          <van-button  @click="openBind">我的客户</van-button>
        </div>
        <van-image
          class="overlay-close"
          width="50" height="50"  
          :src="closeOverlay"
          @click="showQrcode = false" />
      </van-popup>

    </div>
    <!-- 推广客户 -->
    <van-popup v-model="showYourCustomers" closeable
    :style="{ height: '100%', width:'100%',background:'#F7F8F9'}">
      <div class="bind-people-two">我的客户({{total_customers}})</div>
      <div v-if="my_customers&&my_customers.length>0" class="customer_box">
        <!-- <div v-for="(item,index) in my_customers" :key="index" class="c_row"><i class="iconfont iconcustomer"></i><span>{{item.userid | userFilter}}({{ item.mobile | mobileFilter }})</span></div> -->
        <div v-for="(item,index) in my_customers" :key="index" class="c_row">
          <div class="avatar"><van-image :src="user_customer"/></div>
          <div class="c_cell">
            <div class="c_user">{{item.userid | userFilter}}({{ item.mobile | mobileFilter }})</div>
            <div class="c_info"> 
              <div class="c_regtime">{{item.regtime | dateFilter}} </div>
              <div class="c_ver"><img :src="item.isbuy?zyb:tyb" /></div>
            </div>
          </div>
        </div>
      </div>
      <van-empty style="height: 82%;"  v-else description="无" />
      <van-pagination class="c_page" v-model="current_page" :page-count="page_count" mode="simple" @change="customer_changepage" />
    </van-popup>


    
    <!-- 绑定分销商pop -->
    <van-popup v-model="showBindJgjPop" closeable
    :style="{ height: '100%', width:'100%'}">
      <div class="bind-people-two">绑定分销商</div>
      <div style="text-align:center">
        <img class="bind-img" src="../assets/login/bind2.jpg" />
      </div>
      <div style="text-align:center">
        <img class="bind-img" src="../assets/login/bind3.jpg" />
      </div>
      <div style="text-align:center; position: relative">
        <img class="bind-img" src="../assets/login/bind4.png" />
        <span class="jgj-link" @click="showLinkSta()">分销商操作指引</span>
      </div>
      <h1 style="text-align:center; margin: 10px 0">盘活资源，实现躺赚</h1>
      <div style="text-align:center; margin: 10px 0; color: red">将以手机号码:{{ phone | mobileFilter }}绑定分销商</div>
      <div v-if="bindJgjSta" class="bindJgj-wapper">
        <van-button class="albindJgj-btn" disabled size="small">
          已绑定
        </van-button>
      </div>
      <div v-else class="bindJgj-wapper" @click="sureBind">
        <van-button class="bindJgj-btn" size="normal">确认绑定</van-button>
      </div>
    </van-popup>
   
    <van-popup v-model="showpic" @click="showpic = false" :style="{ width:'100%'}" closeable>
        <img src="https://www.holywiser.com/docs/A2C341A2-8244-655B-51BF-917C3AFE1DA4.jpg" width="100%" />
    </van-popup>
  </div>
</template>

<script>
import Login from "@/components/common/login";
import { getSMSFrom } from "@/utils/lib/tools";
import TripleDES from "@/utils/lib/crypto.js";
import baseConfig from "../../public/config.json";
import { commonToast } from "@/utils/lib/toast.js";
import QRCode from "qrcodejs2"
import { getUrlParam} from "@/utils/lib/searchtoobj.js";
import { ImagePreview } from 'vant';
import Promotion from '@/components/common/promotion'
import moment from 'moment'
export default {
  data() {
    return {
      my_customers: [],
      current_page: 1,
      page_count: 0,
      total_customers:0,
      images: [
        'https://www.holywiser.com/docs/A2C341A2-8244-655B-51BF-917C3AFE1DA4.jpg',
      ],
      zyb: require("../assets/index/zyb.png"),
      tyb:require("../assets/index/tyb.png"),
      user_customer: require("../assets/login/user_customer.png"),
      basicVersion:require('@/assets/shop/un_base.png'),
      majorVersion:require('@/assets/shop/major.png'),
      showpic:false,
      versionSta: 2,
      bindTel: '',
      bindSms: '',
      count: 60,  //60s开始倒计时
      isSend: false, // 是否在发送验证码
      timers: null,
      bindPhonePop: false, // 绑定手机号弹窗
      bindResetWxPop: false, // 绑定重置微信弹窗
      // 输入错误时提示语

      show: false,
      show1: false,
      showAccMsg: false,
      updPassword: false, // 修改密码
      feedBack: false, // 意见反馈
      privilege: false, // 我的特权
      changeFlag: true, // 切换版本
      radio: "1",
      radioWord: "全国版",
      feedBackMessage: "", // 反馈内容
      showOldPhonePopup: false, // 修改手机号码 旧手机号码
      showNewPhonePopup: false, // 修改手机号码 新手机号码
      showChangeAcount: false, // 微信登录后修改账号
      btntxt: "发送验证码",
      disabled: false, // 禁用发送验证码按钮
      time: 0, // 倒计时
      pattern: /^1[3456789]\d{9}$/, // 手机号码验证
      oldMoblie: "", // 旧手机号码
      oldCode: "", // 验证旧手机号码的验证码
      newMoblie: "", // 新手机号码
      newCode: "", // 验证新手机号码的验证码
      errMsg: {
        oldcode: "", // 验证码
        newcode: "",
        newMobile: "", // 新手机号码
        oldPwd: "", // 旧密码
        newPwd: "", // 新密码
        confirmPwd: "", // 确认密码

        bindTel: '',
        bindSms: ''
      },
      activePhone: 0, // 步骤条
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",

      // 微信下
      changeAccountMobile: "",
      changeAccountCode: "",
      showQrcode: false, //是否展示推广码pop
      spreadLink: '', // 推广码链接
      showBindJgjPop: false, // 是否展示绑定金管家pop
      showYourCustomers: false,//是否显示推广客户信息
      bindJgjSta: false, // 是否已经绑定金管家标志
      bindJgjId: 0, // 绑定的金管家id
      showSurePop: false,
      spreadCode: '',
      showPdf: false,
      txImg: require("../assets/index/tgm.png"),
      spreadImg: require("../assets/index/spread.png"),
      frameImg: require("../assets/index/frame.png"),
      closeOverlay: require("../assets/index/bindclose.png"),
      stepOne: require("../assets/login/one.png"),
      stepTwo: require("../assets/login/two.png"),
      stepThree: require("../assets/login/three.png"),
      stepOneUn: require("../assets/login/un_one.png"),
      stepTwoUn: require("../assets/login/un_two.png"),
      stepThreeUn: require("../assets/login/un_three.png"),
      showCommissionPop: false,
      showUsersPop: false
    };
  },
  components: {
    Login,
    [ImagePreview.Component.name]: ImagePreview.Component,
    Promotion
  },
  created() {
    if(this.$route.name != "PolicyMate") {
      this.getSpreadLink()
    }
  },
  computed: {
    mallver() {
      return this.$store.state.user.mallver
    },
    maxopennum() {
      return this.$store.state.user.maxopennum;
    },
    isaccedit () {
      return this.$store.state.user.isaccedit;
    },
    userId() {
      return this.$store.state.user.userId;
    },
    phone() {
      return this.$store.state.user.mobileNum;
    },
    // 获取版本
    getVersionWord() {
      return this.$store.state.changeVersion.changeWord;
    },
    accountstatus() {
      return this.$store.state.user.accountstatus;
    },
    accounttype() {
      return this.$store.state.user.accounttype;
    },
    wxopenid() {
      return this.$store.state.user.wxopenid;
    },
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    wxunionid() {
      return this.$store.state.user.wxunionid;
    },
    actionOptions() {
      let actions = [{
        name: '账号中心'
      }, {
        name: '推广码'
      }, {
        name: this.phone && this.userId ? '重置密码' : null 
      }, {
        name: this.phone ? '更换手机' : '绑定手机' 
      }, {
        name: this.wxunionid === ''? '关联微信' : null
      }, {
        name: this.wxunionid !== '' && this.phone ? '重置微信' : null
      }, {
        name: this.userId ? '修改密码' : null 
      }, {
        name: this.isaccedit == true ? '修改账号' : null
      }, {
        name: '退出登录',
        color: '#ed4014'
      }]
      return actions.filter(item => item.name)
    }
  },
  // 过滤电话号码
  filters: {
    mobileFilter(val) {
      let reg = /^(.{3}).*(.{4})$/;
      if (val) {
        return val.replace(reg, "$1****$2");
      } else { 
        return "****"
      }
    },
    //匹配用户名
    // ^ 符号表示匹配字符串的开始。
    // (.{2})：第一个捕获组，匹配任意两个字符，代表字符串的前两个字符。
    // .{3}：匹配接下来的任意三个字符，这是我们想要替换为星号的部分。
    // (.*)：第二个捕获组，匹配任意数量的字符（包括零个字符），代表字符串中剩余的部分。
    // $ 符号表示匹配字符串的结束。
    userFilter(val) {
      let reg = /^(.{2}).{3}(.*)$/;;
      if (val) {
        return val.replace(reg, "$1***$2");
      }
    },
    dateFilter(val) {
      let t1 = moment(val).utcOffset(0).format("YYYY-MM-DD")
          return t1
    },
  },
  methods: {
    openCommissionPop() {
      this.showCommissionPop = true
      this.showQrcode = false
    },
    openUsersPop() {
      this.showUsersPop = true
      this.showQrcode = false
    },
    showLinkSta() {
      this.showpic = true
      console.log("222")
    },
    // 打开绑定金管家pop
    openBind() {
      // this.showQrcode = false
      // this.showBindJgjPop = true
      this.current_page = 1
      this.get_customers()
    },
    // 关闭绑定金管家pop
    closeBind() {
      this.showBindJgjPop = false
    },
    customer_changepage(index) { 
      this.current_page = index
      this.get_customers()
    },
    get_customers() {
      let args = {
        page:this.current_page,
        line:5
      }
      this.$http.reqGetMyCustomers(args)
        .then((res) => {
          console.log(res)
          this.showYourCustomers = true
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.my_customers=res.item.items
              this.current_page = res.item.page
              this.page_count = res.item.pagetotal
              this.total_customers=res.item.total
            }
          }
        })
    },
    sureBind() {
      this.$dialog
      .confirm({
        title: "确认绑定分销商",
        message:"若您未注册分销商账号，本流程将自动为您注册分销商并关联云擎账号,确认绑定吗?",
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
      .then(() => {
        this.bindJgj()
      })
      .catch((err) => {
        //this.showBindJgjPop = false
      })
    },
    // 获取生成二维码的地址
    getSpreadLink() {
      this.$http.reqSpreadLink({})
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.spreadLink = res.result.spreadlink
              this.bindJgjId = res.result.jgjid
              
              //console.log('spreadLink', this.spreadLink)

              if(this.bindJgjId != 0) {
                this.bindJgjSta = true
              }
            } else {
              commonToast(res.rltdesc, this);
            }
          } else {
            commonToast(res.rtndesc, this);
          }
        })
    },
    // 生成二维码
    generateQRcode() {
      if (this.$refs.deposit_qrcode) {
        this.$refs.deposit_qrcode.innerHTML = "";
      }
      this.$nextTick(() => {
        new QRCode("deposit_qrcode", {
          width: 200,
          height: 200,
          text: this.spreadLink,
        });
      });
    },
    // 刷新绑定状态
    refreshBindSta () {
      this.$http.reqSpreadLink({})
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.bindJgjId = res.result.jgjid
              if(this.bindJgjId != 0) {
                this.bindJgjSta = true
              }
            } else {
              commonToast(res.rltdesc, this);
            }
          } else {
            commonToast(res.rtndesc, this);
          }
        })
    },
    // 绑定金管家
    bindJgj() {
      this.$http.reqBindjgj({})
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              commonToast("绑定成功", this);
              this.refreshBindSta()
            } else if(res.rltcode === -1022) {
              commonToast(res.rltdesc, this);
            } else {
              commonToast(res.rltdesc, this);
            }
          } else {
            commonToast(res.rtndesc, this);
          }
        })
    },
    // 获取验证码
    getSmsCode (curSrc) {
      if (curSrc == 6) {
        if (!this.bindTel) {
          this.errMsg.bindTel = '请输入手机号'
          return false
        } else if (!this.pattern.test(this.bindTel)) {
          this.errMsg.bindTel = '手机号格式错误'
          return false
        } else {
          this.errMsg.bindTel = ''
        }
      }
      this.countDown()
      this.isSend = true
      this.verificateCode = ''
      if (curSrc == 6) {
        this.$http.reqSmsCode({
          mobilenum: this.bindTel,
          reqsrc: 6,
        })
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              commonToast("发送验证码成功", this);
              // this.$toast.success('发送验证码成功');
            } else {
              commonToast(res.rltdesc, this);
            }
          } else {
            commonToast(res.rtndesc, this);
          }
        })
      } else {
        this.$http.reqSmsCode({
          mobilenum: this.$store.state.user.mobileNum,
          reqsrc: 8,
        })
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              commonToast("发送验证码成功", this);
            } else {
              commonToast(res.rltdesc, this);
            }
          } else {
            commonToast(res.rtndesc, this);
          }
        })
      }
      
    },
    sureVerify (e) {
      if (!this.bindSms) {
        this.errMsg.bindSms = '请输入短信验证码'
        return false
      } else {
        this.errMsg.bindSms = ''
      }
      if (e === 6) {
        this.$http.reqRegCheckSmsCode(this.bindTel,this.bindSms,6)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                // this.$toast.success('验证码正确');
                this.bindPhone()
              } else {
                commonToast(res.rltdesc, this);
                this.bindSms = ''
              }
            } else {
              commonToast(res.rtndesc, this);
              this.bindSms = ''
            }
          })
      } else {
        this.$http.reqRegCheckSmsCode(this.$store.state.user.mobileNum,this.bindSms,8)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.resetWx()
              } else {
                commonToast(res.rltdesc, this);
                this.bindSms = ''
              }
            } else {
              commonToast(res.rtndesc, this);
              this.bindSms = ''
            }
          })
      }
    },
    // 关闭绑定手机弹窗
    closeBindPhone () {
      this.bindPhonePop = false
    },
    // 关闭重置
    closeResetWx () {
      this.bindResetWxPop = false
    },
    // 重置微信
    resetWx () {
      this.$http.reqResetWx({
        smscode: this.bindSms
      }).then((res) => {
        if (res.rtncode === 1) {
          if (res.rltcode === 1) {
            commonToast("重置微信成功", this);
            this.bindResetWxPop = false
            this.$http.refreshToken().then((res) => {
              this.bus.$emit("saveTokenHandle", res, 1);
            });
          } else {
            commonToast(res.rltdesc, this)
          }
        } else {
          commonToast(res.rtndesc, this)
        }
      })
    },
    // 绑定手机号
    bindPhone () {
      var bodyJson = {
        mobile: this.bindTel,
        smscode: this.bindSms
      };
      this.$http
          .reqBindPhone(bodyJson)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                commonToast("绑定手机号成功", this);
                this.$store.commit("user/setMobileNum", this.bindTel);
                sessionStorage.setItem("phone", this.bindTel);
                this.bindPhonePop = false
              } else {
                commonToast(res.rltdesc, this);
                this.bindSms = ''
              }
            } else {
              commonToast(res.rtndesc, this);
              this.bindSms = ''
            }
          })
    },
    // 倒计时函数60s
    countDown() {
      const TIME_COUNT = 60
      if (!this.timers) {
      this.count = TIME_COUNT
        this.timers= setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
          this.count = this.count - 1
          } else {
          this.count = TIME_COUNT
          this.isSend = false
            clearInterval(this.timers)
          this.timers = null
          }
        }, 1000)
      }
    },
    // 确认更新密码
    confirmUpdatePwd() {
      console.log("修改密码确认按钮");
      if (!this.oldPwd || !this.newPwd || !this.confirmPwd) {
        this.checkOldPwd();
        this.changeNewPwd();
        this.changeConfirmPwd();
        this.updPassword = true;
      } else if (this.errMsg.newPwd != "" || this.errMsg.confirmPwd != "") {
        this.updPassword = true;
      } else {
        let params = {
          oripwd: this.oldPwd,
          newpwd: this.newPwd,
        };
        this.$http
          .reqUpdatePwd(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                commonToast("修改密码成功", this);
                let datapwd = TripleDES.encode("accoutPwd", this.newPwd)
                localStorage.setItem('accoutPwd', datapwd)
                
                this.updPassword = false;
                this.oldPwd = "";
                this.newPwd = "";
                this.confirmPwd = "";
                
              } else {
                commonToast(res.rltdesc, this);
              }
            } else {
              commonToast(res.rtndesc, this);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    checkOldPwd() {
      if (!this.oldPwd) {
        this.errMsg.oldPwd = "请输入旧密码";
        return false;
      } else {
        this.errMsg.oldPwd = "";
        return true;
      }
    },
    changeNewPwd() {
      if (!this.newPwd) {
        this.errMsg.newPwd = "请输入新密码";
        return false;
      } else if (this.newPwd.length < 6) {
        this.errMsg.newPwd = "密码长度至少6位";
        return false;
      } else if (this.confirmPwd && this.newPwd !== this.confirmPwd) {
        this.errMsg.confirmPwd = "两次密码不一致";
        return false;
      } else {
        this.errMsg.newPwd = "";
        return true;
      }
    },
    changeConfirmPwd() {
      if (!this.confirmPwd) {
        this.errMsg.confirmPwd = "请输入确认密码";
        return false;
      } else if (this.newPwd !== this.confirmPwd) {
        this.errMsg.confirmPwd = "两次密码不一致";
        return false;
      } else {
        this.errMsg.confirmPwd = "";
        return true;
      }
    },
    // 登录
    login() {
      this.$refs.alertModel.changeShowLogin(true);
    },
    refreshProtect() {
      this.$router.replace(this.$route.path + '?relogin=2')
    },
    // 申请试用
    applyLogin() {
      this.$refs.alertModel.changeShowApplyLogin(true);
    },
    onSelect(item) {
      // console.log('item==>', item)
      this.show = false;
      if (item.name === "账号信息") {
        this.showAccMsg = true;
      } else if (item.name === "推广码") {
        this.showQrcode = true
        this.generateQRcode()
      } else if (item.name === "绑定手机") { 
        console.log("绑定手机");
        this.bindPhonePop = true
      } else if (item.name === "重置微信") {
        console.log("重置微信");
        this.bindResetWxPop = true
      } else if (item.name === "账号中心") {
        if (this.accountstatus == 300 || this.accountstatus == 400) {
          commonToast("请先在线商城购买产品后使用", this);
        } else {
          this.$router.push("personalCenter");
        }
      } else if (item.name === "修改密码") {
        this.updPassword = true;
      } else if (item.name === "重置密码") {
        this.$refs.alertModel.changeResetPassword(true);
      } else if (item.name === "更换手机") {
        this.showOldPhonePopup = true;
      } else if (item.name === "意见反馈") {
        this.feedBack = true;
      } else if (item.name === "我的特权") {
        this.privilege = true;
      } else if (item.name === "会员续费") {
        console.log("会员续费");
      } else if (item.name === "退出登录") {
        this.$dialog
          .confirm({
            title: "提示",
            message: "确定退出登录吗",
            confirmButtonText: "确定",
          })
          .then(() => {
            this.$store.state.changeVersion.jumpPage = 0;
            this.$store.commit("user/setUserId", "");
            this.$store.commit("user/setUserGuid", "");
            this.$store.commit("user/setRealName", "");
            this.$store.commit("user/setToken", "");
            this.$store.commit("user/setMobileNum", "");
            this.$store.commit("user/setAccountType", 0);
            this.$store.commit("user/setPermission", []);
            this.$store.commit("user/setAccountStatus", 0);
            this.$store.commit("user/setShowMsg", "");
            this.$store.commit("user/setPermissionArray", []);
            this.$store.commit("user/setWxOpenId", "");
            this.$store.commit("user/setWxUnionId", "");
            this.$store.commit("user/setAgentCode", "");

            this.$store.commit("commonSearchData/changeActiveName", "a");
            this.$store.commit("changeVersion/setChangeFlagWord", "地方版");

            this.$store.commit("changeVersion/setChangeFlag", false);
            this.$store.commit(
              "commonSearchData/changeValueP",
              localStorage.getItem("valueP")
            );
            this.$store.commit(
              "commonSearchData/changeValueC",
              localStorage.getItem("valueC")
            );
            this.$store.commit(
              "commonSearchData/changeValueProvCode",
              localStorage.getItem("valueProvCode")
            );
            this.$store.commit(
              "commonSearchData/changeValueCityCode",
              localStorage.getItem("valueCityCode")
            );

            localStorage.setItem("selectedId", "a");
            this.$cookie.delete("cookieObjByUserid")
            this.$cookie.delete("cookieObjByWx")
            sessionStorage.clear();
            this.$cookie.delete("cookieObj");

            localStorage.removeItem('accoutName')
            localStorage.removeItem('accoutPwd')

            //console.log("uiuiui1===>",localStorage.getItem('accoutName'))
            if(this.$route.path !='/policyMate') {
              this.$router.replace({ path: "/index" });
            } else {
              this.$store.commit("commonSearchData/changeActiveName", "r");
              this.$router.replace(this.$route.path + '?relogin=1')
            }
          })
          .catch(() => {
            // on cancel
          });
      } else if (item.name === "修改账号") {
         if(this.phone === '') {
          this.$notify({
            color: "#fff",
            background: "#F27852",
            message: "请先绑定手机号!",
            duration: 5000,
          });
           this.bindPhonePop = true
           return false
         }
        this.$refs.alertModel.openEditUser();
      } else if (item.name === "关联微信") {
        this.$dialog
          .confirm({
            message: "是否关联微信",
            confirmButtonText: "是",
            cancelButtonText: "否",
            confirmButtonColor: "#4D8FFE"
          })
          .then(async () => {
            let res = await this.$http.reqPostGetWeixinPromise({
              http_redirct: baseConfig.wxUserBindRedirectUrl,
            });
            console.log(res);
            if (res.rtncode === 1 && res.rltcode === 1) {
              location.href = res.item.url;
            }
          })
          .catch((err) => {
            console.log("关联微信====>", err);
          });
      }
    },
    // 验证申请试用验证码
    changeCode() {
      if (!this.oldCode) {
        this.errMsg.oldcode = "请输入验证码";
        return false;
      } else {
        this.errMsg.oldcode = "";
      }
    },
    changeCodeNew() {
      if (!this.newCode) {
        this.errMsg.newcode = "请输入验证码";
        return false;
      } else {
        this.errMsg.newcode = "";
      }
    },
    // 验证新手机号码
    checkNewMobile() {
      if (!this.newMoblie) {
        this.errMsg.newMobile = "请输入手机号码";
        return false;
      } else if (!this.pattern.test(this.newMoblie)) {
        this.errMsg.newMobile = "手机号码输入有误，请重新输入";
        return false;
      } else {
        this.errMsg.newMobile = "";
        return true;
      }
    },
    // 关闭验证旧手机号弹框之前
    beforeOldPhoneClose() {
      if (!this.phone || !this.oldCode) {
        this.changeCode();
        this.showOldPhonePopup = true;
        // ljw
        //this.showNewPhonePopup = true;
      } else {
        this.$http
          .reqRegCheckSmsCode(
            this.phone,
            this.oldCode,
            getSMSFrom.SMS_CODE_TYPE_OLD_PHONE
          )
          .then((response) => {
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                this.showNewPhonePopup = true;
                this.showOldPhonePopup = false;
                this.activePhone = 1;
              } else {
                this.$notify({ duration: 5000, message: response.rltdesc });
                this.showOldPhonePopup = true;
              }
            } else {
              this.$notify({ duration: 5000, message: response.rtndesc });
              this.showOldPhonePopup = true;
            }
          })
          .catch((err) => {
            this.$notify({ duration: 5000, message: err.message });
            this.showOldPhonePopup = true;
          });
      }
    },
    // 关闭新手机号码弹框之前
    beforeNewPhoneClose() {
      if (!this.newMoblie || !this.newCode) {
        this.checkNewMobile();
        this.changeCodeNew();
        this.showNewPhonePopup = true;
      } else {
        this.$http
          .reqRegCheckSmsCode(
            this.newMoblie,
            this.newCode,
            getSMSFrom.SMS_CODE_TYPE_NEW_PHONE
          )
          .then((response) => {
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                // 修改手机号码
                let params = {
                  mobilenum_old: this.phone,
                  smscode_old: this.oldCode,
                  mobilenum_new: this.newMoblie,
                  smscode_new: this.newCode,
                };
                console.log("params", params);
                this.$http
                  .reqMobileUpdate(params)
                  .then((resp) => {
                    if (resp.rtncode === 1) {
                      if (resp.rltcode === 1) {
                        sessionStorage.setItem("phone", this.newMoblie);
                        this.$store.commit("user/setMobileNum", this.newMoblie);
                        let data = TripleDES.decode(
                          "token",
                          JSON.parse(this.$cookie.get("cookieObj"))
                        );
                        data.phone = this.newMoblie;
                        this.$cookie.set(
                          "cookieObj",
                          JSON.stringify(TripleDES.encode("token", data)),
                          4
                        );
                        this.$notify({
                          color: "#fff",
                          background: "#F27852",
                          message: "手机号码更换成功",
                          duration: 5000,
                        });
                        this.showNewPhonePopup = false;
                      } else {
                        this.$notify({ duration: 5000, message: resp.rltdesc });
                        this.showNewPhonePopup = false;
                      }
                    } else {
                      this.$notify({ message: resp.rtndesc, duration: 5000 });
                      this.showNewPhonePopup = false;
                    }
                  })
                  .catch((err) => {
                    this.$notify({ duration: 5000, message: err.message });
                    this.showNewPhonePopup = true;
                  });
              } else {
                this.$notify({ duration: 5000, message: response.rltdesc });
                this.showNewPhonePopup = true;
              }
            } else {
              this.$notify({ duration: 5000, message: response.rtndesc });
              this.showNewPhonePopup = true;
            }
          })
          .catch((err) => {
            this.$notify({ duration: 5000, message: err.message });
            this.showNewPhonePopup = true;
          });
      }
    },
    // 点击发送验证码
    sendcode(num) {
      if (num === 1) {
        // 验证身份  旧手机号码

        this.$http
          .reqSmsCode({
            mobilenum: this.phone,
            reqsrc: getSMSFrom.SMS_CODE_TYPE_OLD_PHONE,
          })
          .then((response) => {
            console.log("response发送验证码-旧手机号", response);
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                this.$notify({
                  color: "#fff",
                  background: "#F27852",
                  message: "验证码发送成功",
                  duration: 5000,
                });
                this.time = 60;
                this.disabled = true;
                this.timer();
              } else {
                this.$notify({ message: response.rltdesc, duration: 5000 });
              }
            } else {
              this.$notify({ message: response.rtndesc, duration: 5000 });
            }
          })
          .catch((err) => {
            this.$notify({ message: err.message, duration: 5000 });
          });
      } else if (num === 2) {
        // 更换手机号码  新手机号码
        if (this.newMoblie && /^1[3456789]\d{9}$/.test(this.newMoblie)) {
          this.$http
            .reqSmsCode({
              mobilenum: this.newMoblie,
              reqsrc: getSMSFrom.SMS_CODE_TYPE_NEW_PHONE,
            })
            .then((response) => {
              if (response.rtncode === 1) {
                if (response.rltcode === 1) {
                  this.$notify({
                    color: "#fff",
                    background: "#F27852",
                    message: "验证码发送成功",
                    duration: 5000,
                  });
                  this.time = 60;
                  this.disabled = true;
                  this.timer();
                } else {
                  this.$notify({ message: response.rltdesc, duration: 5000 });
                }
              } else {
                this.$notify({ message: response.rtndesc, duration: 5000 });
              }
            })
            .catch((err) => {
              this.$notify({ message: err.message, duration: 5000 });
            });
        }
      } else if (num === 3) {
        this.$http
          .reqSmsCode({
            mobilenum: this.changeAccountMobile,
            reqsrc: getSMSFrom.SMS_CODE_TYPE_CHECK_PHONE,
          })
          .then((response) => {
            console.log("微信修改账号验证码", response);
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                this.$notify({
                  color: "#fff",
                  background: "#F27852",
                  message: "验证码发送成功",
                  duration: 5000,
                });
                this.time = 60;
                this.disabled = true;
                this.timer();
              } else {
                this.$notify({ message: response.rltdesc, duration: 5000 });
              }
            } else {
              this.$notify({ message: response.rtndesc, duration: 5000 });
            }
          })
          .catch((err) => {
            this.$notify({ message: err.message, duration: 5000 });
          });
      }
    },
    // 打开验证身份弹框
    openOldPhonePopup() {
      this.oldCode = "";
      this.newMoblie = "";
      this.newCode = "";
      this.time = 0;
      this.btntxt = "获取验证码";
      this.disabled = false;
      this.activePhone = 0;
    },
    // 打开新手机号码弹框
    openNewPhonePopup() {
      this.newMoblie = "";
      this.newCode = "";
      this.time = 0;
      this.btntxt = "获取验证码";
      this.disabled = false;
      this.activePhone = 1;
    },
    // 关闭意见反馈弹框
    clocsFeed() {
      this.feedBack = false;
      this.feedBackMessage = "";
    },
    // 点击意见反馈弹框里的确定按钮
    confirmFeedBack() {
      if (this.feedBackMessage) {
        let params = {
          suggestions: this.feedBackMessage,
        };
        this.$http
          .reqCreateFeedBack(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.$notify({
                  color: "#fff",
                  background: "#F27852",
                  message: "意见反馈成功",
                  duration: 5000,
                });
                this.feedBack = false;
              } else {
                this.feedBack = false;
              }
            } else {
              this.feedBack = false;
            }
          })
          .catch(() => {
            this.feedBack = false;
          });
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请输入意见/反馈内容",
          duration: 5000,
        });
      }
    },
    // 切换版本
    changeVersion(value) {
      if (value === "1") {
        this.changeFlag = true;
        this.radioWord = "地方版";
        this.show1 = false;
        this.$router.push("newFiles");
      } else if (value === "2") {
        this.changeFlag = false;
        this.radioWord = "全国版";
        this.show1 = false;
        this.$router.push("newFilesD");
      }
      localStorage.getItem("selectedId", "a");
      this.$store.commit("commonSearchData/changeActiveName", "a"); // 每次切换 都选中政策法规

      localStorage.setItem("changeFlag", this.changeFlag);
      localStorage.setItem("changeFlagWord", this.radioWord);
      this.$store.commit("changeVersion/setChangeFlag", this.changeFlag);
      this.$store.commit("changeVersion/setChangeFlagWord", this.radioWord);

      this.$store.commit("commonSearchData/changeActiveName", "a");
      this.$store.commit("commonSearchData/changeActive", 0); // 每次切换都选中通用规定
      this.$store.commit(
        "commonSearchData/changeValueP",
        localStorage.getItem("valueP")
      );
      this.$store.commit(
        "commonSearchData/changeValueC",
        localStorage.getItem("valueC")
      );
      this.$store.commit(
        "commonSearchData/changeValueProvCode",
        localStorage.getItem("valueProvCode")
      );
      this.$store.commit(
        "commonSearchData/changeValueCityCode",
        localStorage.getItem("valueCityCode")
      );
    },
    showMenu() {
      this.show = true;
    },
    // 默认样式
    themeDefault() {
      document.body.className = "theme_default";
      localStorage.setItem("themeColor", "theme_default");
    },
    // 青绿色
    themeGreen() {
      document.body.className = "theme_darkgreen";
      localStorage.setItem("themeColor", "theme_darkgreen");
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    // 刷新
    repalyBtn() {
      console.log(this.$route);
      if (this.$route.name !== "NewFiles") {
        this.$router.push("/newFiles");
      } else {
        this.$nextTick(() => {
          this.bus.$emit("replayNews");
        });
      }
    },
  },
  watch: {
    getVersionWord(newValue, oldValue) {
      if (newValue === "地方版") {
        this.$nextTick(() => {
          this.radio = "1";
        });
      } else {
        this.$nextTick(() => {
          this.radio = "2";
        });
      }
    },
  },
  beforeDestroy() {
    this.bus.$off("openCreateAcount");
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
// @import "~@/styles/user.less";
/deep/.van-icon {
  color: #000;
}
#updatePwd-dialog {
  font-size: 20px;
  /deep/.van-cell {
    margin-top: 20px;
  }
  
}
.edit-phone-img {
  width: 17px;
  height: 17px;
}
#loginContainer {
  height: 40px;
  color: #515a6e;
  
  .version{
    display: flex;
    align-items: center;
    margin-right: 10px;
    justify-content: space-between;
    span {
      color: white;
    }
    
  }
  .version-one {
    margin-right: 3px;
    margin-top: 2px;
    width: 16px;
  }
  .version-two {
    width: 16px;
    margin: 2px 3px 0 2px;
  }
  .version-three {
    margin-right: 2px;
  }
  
  .bind-phone-dialog, .reset-wx-dialog {
    padding: 0 20px 20px 20px;
    /deep/.van-dialog__header {
      color: #000;
      font-weight: bold;
      padding-top: 15px;
    }
    .nav-title {
      font-size: 12px;
      color: #404040;
      padding: 0 0 0 15px;
    }
    .bind-close-icon, .reset-wx-icon {
      position: fixed;
      top: 5%;
      left: 90%;
      color: #000000;
    }
    .login-btn-wapper {
      text-align: center;
      margin-top: 30px;
      .login-btn {
        background: 
        -webkit-gradient(linear, 0 0, 0 100%, from(#00A9FF), to(#0080FF));
        color: white;
        border: 1px solid #0080FF;
        width: 90%;
        height: 40px;
      }
    }
    .apply-forget {
      text-align: center;
      font-size: 14px;
      color: #000;
      span {
        margin-right: 12px;
      }
      
      /deep/.van-tabs__wrap {
        margin-top: 20px;
      }
      /deep/.van-tabs__line {
        background: #0077F5;
      }
      /deep/.van-cell-group {
        margin-top: 20px;
        margin: 20px 5px 0 5px;
      }
      .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border: none;
      }
      /deep/.van-cell {
        border: 1px solid #ddd;
        border-radius: 5px;
        margin:0 20px 20px 20px;
        width: 90%;
        padding: 10px 10px;
      }
    }
    .verificate-code {
      // background: -webkit-gradient(linear, 0 0, 0 100%, from(#907456), to(#715641));
      //color: white;
      //border: 1px solid #715641;
      color: #328EFF;
      border-radius: 3px;
      width: 86px;
    }
  }
  
  .loginBox {
    //height: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
    font-size: 14px;
    box-sizing: border-box;

    .logo {
      display: flex;
      align-items: center;
      img {
        height: 24px;
      }
    }

    .login {
      position: relative;
      display: flex;
      align-items: center;
      .word {
        margin-right: 10px;
        font-weight: 600;
      }
      // .van-icon {
      //   width: 26px;
      //   height: 26px;
      //   margin-right: 10px;
      // }
      .userBGTitle {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        //max-width: 85px;
        color: white;
        padding: 3px 0px 3px 18px;
        font-size: 14px;
        span {
          margin-right: 20px;
          max-width: 80px;
          overflow:hidden;
          text-overflow:ellipsis; 
        }
        &::after {
          position: absolute;
          top: 10px;
          right: 60px;
          content: "";
          border: 4px solid transparent;
          border-top: 4px solid #ffffff;
        }
      }
      .versionV1 {
        &::before {
          left: 87px;
        }
      }
      .replay {
        margin-left: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
        .replayimg {
          width: 14px;
          height: 14px;
          color: #FFFFFF;
        }
        span {
          margin-left: 2px;
        }
      }
    }
  }
  .acc {
    line-height: 40px;
    margin: 0 30px;
    font-size: 14px;
  }
}
.van-cell {
  border-bottom: 1px solid #F0F0F0;
  border-radius: 6px;
  min-height: 30px;
}
[class*=van-hairline]::after {
  border:none
}
.van-popup--bottom.van-popup--round {
  border-radius: 10px 10px 0 0;
}
/deep/.van-cell:not(:last-child)::after {
  border-bottom: none;
}
/deep/.van-field__control {
  font-size: 12px;
}
/deep/.van-popup--center {
  border-radius: 15px;
}
/deep/.van-step__title {
  color: #000;
  font-size: 13px;
}
/deep/.van-step__title--active {
  color: #07C160;
}
.exchange-wapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
  /deep/.van-cell {
    width: 230px;
    margin-top: 0;
    border: 1px solid #d7d7d7;
    border-radius: 0px;
  }
  /deep/.van-button--info {
    background: linear-gradient(to right, #fff, #fff);
    border: 1px solid #D7D7D7;
    color: #000;
  }
  /deep/.van-button {
    min-height: 45px;
  }
}
.new-exchange-wapper {
  /deep/.van-cell {
    border: 1px solid #F0F0F0;
    margin: 10px 0;
  }
}

</style>
<style lang="less">
@import "~@/styles/variable.less";
  .promotion-pop {
    .van-popup__close-icon {
      color: white;
    }
  }
  .qr-pop {
    .van-popup {
      background: url(../assets/index/spread.png) no-repeat;
      // background-size: contain;
      background-size: cover;
    }
    .van-popup__close-icon {
      color: white;
    }
  }

.qr-top-section {
  display: flex;
  justify-content: center;
  align-items: center;
  .van-image {
    margin: 20px 0 20px -50px;
  }
  .information-box {
    color: white;
    font-size: 14px;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
}

.account-line {
  margin:10px 0 10px 0px;
}

#deposit_qrcode {
  display: flex;
  justify-content: center;
  margin: 30px 40px 8px 40px;
  //background-image: url(../assets/index/frame.png) ;
  //background-size: 100% 100%;
  img {
    padding: 13px;
  }
}



.bind-index {
  text-align: center;
  margin-bottom: 20px;
  color: #19BE6B;
  font-size: 16px;
}
.bind-people {
  text-align: center;
  margin-bottom: 20px;
  .van-button {
    background: linear-gradient(to right,#57D2F3 ,#4BB1FC);
    border-radius: 20px;
    color: white;
  }
}
.already-bind {
  color: #000000;
  font-size: 17px;
  text-align: center;
}
.bind-id {
  color: #666666;
  text-align: center;
  margin: 5px 0 10px 0;
}
.overlay-close {
  position: fixed;
  bottom: 0;
  z-index: 2133;
  left: 45%;
  padding-top: 5px;
  display: none;
}
.bind-people-two {
  color: #2db7f5;
  text-align: center;
  border-bottom: 1px solid #ddd;
  margin: 15px 0 5px 0;
  padding-bottom: 15px;
}
.customer_box {
  display:flex;
  flex-flow: column;
  margin:5% 5%;
  height: 78%;
  position: relative;
  // background-color: #808080;
  .c_row{
    display:flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    margin-bottom: 10px;
    padding-left: 20px;
    height: 80px;
    width: 100%;
    border-radius: 8px;

    .c_cell{
      justify-content: left;
      display:flex;
      flex-flow: column;
      padding-left:10px;
      align-items: center;
      width: 100%;
      .c_user{
        display:flex;
        font-size: 1.2em;
        width: 100%;
        margin-bottom:8px;
        color:#000000;
      }
      .c_info{
        display:flex;
        width: 100%;
        flex:2;
        flex-flow:row;
        .c_regtime{
        display:flex;
        // background: #1989fa;
        width:70%;
        align-items:center;
        color:#999999;
        }
        .c_ver{
        display:flex;
        justify-content: center;
        // background: #19BE6B;
        width:30%;
        img{
          width: auto;
          height: 100%;
          }
        }
      }
      
      
    }
    .avatar {
      display:flex;
      font-size: 1.0em;
      align-items: center;
    }
  
    i{
      font-size: 2em;
      color:#1989fa;
    }

  }
  .c_page{
    position: absolute;
    bottom:0px;
    z-index: 10;
  }
}

.phone-line {
  text-align: center;
}
.pwd-title {
  color: #000000;
  font-size: 17px;
  text-align: center;
  margin: 13px 0 8px 0;
  font-weight: bold;
}

.bind-img {
  width: 100%;
}
.jgj-link {
  text-decoration: underline;
  color: white;
  cursor: pointer;
  position: absolute;
  top: 30px;
  left: 37%;
  font-size: 12px;
}
.bindJgj-wapper {
  text-align:center;
  margin-bottom: 20px;
  .bindJgj-btn {
    background-color: #2db7f5 !important;
    color: #fff;
  }
  .albindJgj-btn {
    color: #525354;
    background-color: #f7f7f7;
    border-color: #bdb8b8;
  }
}
.feed-back-box {
  padding: 0 20px 20px;
  box-sizing: border-box;
  height: 70%;
}
.btn-buju {
  display: flex;
  justify-content: space-between;
  &:before,
  &:after {
    content: "";
    display: block;
  }
}
.privilege {
  font-size: 0.37333rem;
  //padding: 0 10px 10px;
  box-sizing: border-box;
  .word {
    color: #6d6d6d;
  }
  .line {
    width: 100%;
    height: 8px;
    margin: 14px 0;
    background: #f6f6f6;
  }
  .huiyuantequan {
    border: 1px solid #ccc;
    .item-title {
      height: 40px;
      line-height: 40px;
      display: flex;
      border-bottom: 1px solid #ccc;
      background-color: #f8f0e5;
      color: #72563a;
      font-weight: bold;
      & > div {
        flex: 0 0 30%;
        padding: 4px;
      }
    }
    .item-content {
      display: flex;
      height: 40px;
      line-height: 40px;
      font-size: 10px;
      & > div {
        flex: 0 0 30%;
        padding: 4px;
      }
    }
  }
  .vipshengjibao {
    border: 1px solid #ccc;
    .vip-item {
      display: flex;
      border-bottom: 1px solid #ccc;
      height: 40px;
      line-height: 40px;
      background-color: #f8f0e5;
      color: #72563a;
      font-weight: bold;
      & > div {
        flex: 0 0 24%;
        padding: 4px;
      }
    }
    .vip-content {
      display: flex;
      height: 40px;
      line-height: 40px;
      font-size: 10px;
      & > div {
        flex: 0 0 24%;
        padding: 4px;
      }
    }
  }
}
</style>
